/**
 * LogosMarquee — la cinta de logos de cliente que recorre la home.
 *
 * La lista se duplica para que la animación pueda ir de `0` a `-50%` y volver
 * a empezar sin salto visible: el segundo juego entra justo cuando el primero
 * sale. La copia va con `aria-hidden` para que un lector de pantalla no lea
 * dieciocho nombres cuando solo hay nueve marcas.
 *
 * TOLERA QUE FALTE UN FICHERO a propósito. Hoy están los nueve, pero estos
 * logos no salen del código: los trae marketing, y un `<img>` roto en mitad de
 * la cinta sería el fallo más visible de la página. Marcar una entrada como
 * `pendiente: true` la saca de la cinta sin borrarla de la lista, que es lo que
 * quieres cuando una marca pide que la quites un mes.
 *
 * ⚠️ Los logos son marcas de terceros. Antes de que esto llegue a producción
 * hay que confirmar el derecho de uso de cada una — está anotado como pendiente
 * en el plan del rediseño.
 */
const RUTA = '/landing-images/v3';

export const LOGOS_CLIENTE = [
  { clave: 'kfc', alt: 'KFC', src: `${RUTA}/cliente-kfc.png` },
  { clave: 'orange', alt: 'Orange', src: `${RUTA}/cliente-orange.png` },
  { clave: 'fitness-park', alt: 'Fitness Park', src: `${RUTA}/cliente-fitness-park.png` },
  { clave: 'mapfre', alt: 'Mapfre', src: `${RUTA}/cliente-mapfre.png` },
  { clave: 'aqualandia', alt: 'Aqualandia', src: `${RUTA}/cliente-aqualandia.png` },
  { clave: 'marina-dor', alt: "Marina d'Or", src: `${RUTA}/cliente-marina-dor.png` },
  { clave: 'enjoy', alt: 'Enjoy', src: `${RUTA}/cliente-enjoy.png` },
  { clave: 'galerias-madrid', alt: 'Galerías Madrid', src: `${RUTA}/cliente-galerias-madrid.png` },
  { clave: 'grupo-badia', alt: 'Grupo Badía', src: `${RUTA}/cliente-grupo-badia.png` },
];

export default function LogosMarquee({ titulo }) {
  const logos = LOGOS_CLIENTE.filter((l) => !l.pendiente);
  if (logos.length === 0) return null;

  return (
    <div>
      {titulo ? (
        <div className="text-[13.5px] font-semibold text-v3-muted text-center">{titulo}</div>
      ) : null}

      {/*
        EL ANCHO VISIBLE SE FIJA AQUI, no en quien lo monta.

        La cinta se estiraba a lo que le diera el contenedor, y eso la dejaba
        a 1.180 px en la home y a 1.905 —el viewport entero— en
        Multiubicaciones, donde se habia montado fuera de la caja. Once logos
        a la vez no se leen como una cinta que pasa, se leen como una fila
        quieta y un poco desesperada.

        Con 760 px caben unos cuatro y medio: los dos del centro se leen bien
        y los de los bordes estan entrando y saliendo, que es lo que hace que
        parezca que hay muchas mas marcas detras. Ademas el degradado de los
        lados (`mask-image`) se nota, en vez de quedar diluido a lo largo de
        casi dos mil pixeles.
      */}
      <div className="v3-marquee mt-[22px] max-w-[760px] mx-auto">
        <div className="v3-marquee-track">
          {[...logos, ...logos].map((l, i) => {
            const copia = i >= logos.length;
            return (
              <div
                key={`${l.clave}-${i}`}
                className="w-[170px] h-[76px] flex items-center justify-center shrink-0 px-3.5"
              >
                <img
                  src={l.src}
                  alt={copia ? '' : l.alt}
                  aria-hidden={copia || undefined}
                  loading="lazy"
                  className="max-w-full max-h-full object-contain block"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
